import React from 'react';
import { CheckIcon } from 'lucide-react';
import { recipeDesign, volumes } from '../data/eatWellContent';
export function VolumesSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="volumes-title" data-id="element-230" data-mp="3uw8b2no9ardb">
      <div className="mx-auto max-w-5xl px-5" data-id="element-231" data-mp="cm510nt8ybjy">
        <p className="text-center text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-232" data-mp="7qhekg65fwi5">
          Real meals → Execution
        </p>
        <h2 id="volumes-title" className="mt-3 text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-233" data-mp="3g2v9rag7r2pc">
          The 5 recipe volumes
        </h2>

        <div className="mt-8 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-234" data-mp="3l3sw7z89aiwn">
          <ol className="contents" data-id="element-235" data-mp="2xeqbujm8mbyg">
            {volumes.map(v => <li key={v.number} className="flex flex-col border border-charcoal-600 bg-charcoal-800 px-5 py-5" data-id="element-236" data-mp="2xcx2gwk8pdmr">
                <div className="flex items-baseline justify-between gap-3" data-id="element-237" data-mp="29eh10hkkl5jv">
                  <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-champagne" data-id="element-238" data-mp="2eebosc91tf0p">
                    {v.number}
                  </p>
                  <p className="text-[9px] font-medium uppercase tracking-[0.18em] text-muted" data-id="element-239" data-mp="2j63i2ujl9yuj">
                    {v.category}
                  </p>
                </div>
                <h3 className="mt-1.5 font-display text-lg font-semibold uppercase leading-tight text-ivory-50" data-id="element-240" data-mp="1qho4mcg3volb">
                  {v.title}
                </h3>
                <p className="mt-2 text-[14px] leading-snug text-body" data-id="element-241" data-mp="20f2c3mk1x31h">{v.line}</p>
              </li>)}
          </ol>

          <div className="border border-champagne/30 bg-charcoal-950 px-5 py-5" data-id="element-242" data-mp="24hgt0145tsq4">
            <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-champagne" data-id="element-243" data-mp="3builskx9suqk">
              Every recipe
            </p>
            <h3 className="mt-1.5 font-display text-lg font-semibold uppercase leading-tight text-ivory-50" data-id="element-244" data-mp="3ftzs1gkitvws">
              Is designed around
            </h3>
            <ul className="mt-3 space-y-1.5" data-id="element-245" data-mp="1bs9bew6faq73">
              {recipeDesign.map(item => <li key={item} className="flex items-start gap-2" data-id="element-246" data-mp="1ps0v9djmf0t0">
                  <CheckIcon className="mt-1 h-3 w-3 shrink-0 text-champagne" strokeWidth={3} aria-hidden="true" data-id="element-247" data-mp="1pp4xbp7rwc4k" />
                  <span className="text-[13px] leading-snug text-ivory-200" data-id="element-248" data-mp="x0qzpakljhtj">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}